import { render, staticRenderFns } from "./ShopActivityBanner.vue?vue&type=template&id=45db6a7b&scoped=true"
import script from "./ShopActivityBanner.vue?vue&type=script&lang=js"
export * from "./ShopActivityBanner.vue?vue&type=script&lang=js"
import style0 from "./ShopActivityBanner.vue?vue&type=style&index=0&id=45db6a7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db6a7b",
  null
  
)

export default component.exports